"use strict";
var CookieLibrary;
(function (CookieLibrary) {
    function expireCookie(cName) {
        setCookieByDate(cName, "deleted", new Date(0));
    }
    CookieLibrary.expireCookie = expireCookie;
    function setCookieByExDate(cname, cvalue, exdate) {
        var expires = "expires=" + exdate.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    CookieLibrary.setCookieByExDate = setCookieByExDate;
    function setCookieByDate(cname, cvalue, exdate) {
        var expires = "expires=" + exdate.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    CookieLibrary.setCookieByDate = setCookieByDate;
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        var expires = '';
        if (exdays > 0) {
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString();
        }
        else {
            expires = "expires=0";
        }
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    CookieLibrary.setCookie = setCookie;
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }
    CookieLibrary.getCookie = getCookie;
})(CookieLibrary || (CookieLibrary = {}));
//# sourceMappingURL=CookieLibrary.js.map